import * as actionTypes from './actiontypes';
import { PAGE_LOADING, PAGE_LOADED } from '../page_details/actiontypes';
import * as API from './api';
import { showMessage, log } from '../../config/utils';

export function getBotMessages() {
    return function (dispatch) {
        dispatch({
            type: actionTypes.BOT_MESSAGES_LOADING,
        });

        API.getBotMessages({}, (error, response) => {
            log('getBotMessage response', response);
            if (!error) {
                dispatch({
                    type: actionTypes.BOT_MESSAGES_LOADED,
                    payload: response,
                });
            } else {
                dispatch({
                    type: actionTypes.BOT_MESSAGES_ERROR,
                });
            }
        });
    };
}

export function getBotMessagesSchema() {
    return function (dispatch) {
        API.getBotMessagesSchema({}, (error, response) => {
            log('getBotMessage schema response', response);
            if (!error) {
                dispatch({
                    type: actionTypes.BOT_MESSAGE_SCHEMA_LOADED,
                    payload: response,
                });
            } else {
                showMessage('error', response && response.message ? response.message : 'message schema loading failed .');
            }
        });
    };
}

export function deleteBotMessage(payload) {
    return function (dispatch) {
        dispatch({
            type: PAGE_LOADING,
            payload: "bot message deleting"
        });

        API.deleteBotMessage(payload, (error, response) => {
            log('delete BotMessage response', response);
            dispatch({
                type: PAGE_LOADED,
            });

            if (!error) {
                dispatch({
                    type: actionTypes.BOT_MESSAGE_DELETED,
                    payload: response,
                });
                showMessage('success', response && response.message ? response.message : 'Bot message successfully deleted');
            } else {
                showMessage('error', response && response.message ? response.message : 'Bot message deletion failed .');
            }
        });
    };
}

export function resetPopupBotMessage() {
    return function (dispatch) {
        dispatch({
            type: actionTypes.RESET_POPUP_BOT_MESSAGE,
        });
    };
}

export function getBotMessageDetails(payload, callback) {
    return function (dispatch) {
        dispatch({
            type: PAGE_LOADING,
            payload: "message details fetching"
        });

        API.getBotMessageDetails(payload, (error, response) => {
            log('getBotMessage details response', response);
            dispatch({
                type: PAGE_LOADED,
            });

            if (!error && response && response.messageDetails) {
                dispatch({
                    type: actionTypes.BOT_MESSAGE_DETAIL_LOADED,
                    payload: response,
                });
                if (callback) callback();
            } else {
                showMessage('error', response && response.message ? response.message : 'some error occured');
            }
        });
    };
}

export function updateBotMessage(payload, callback) {
    return function (dispatch) {
        dispatch({
            type: actionTypes.BOT_MESSAGE_UPDATING,
        });

        API.updateBotMessage(payload, (error, response) => {
            log('updateBotMessage response', response);
            if (!error) {
                dispatch({
                    type: actionTypes.BOT_MESSAGE_UPDATED,
                    payload: response,
                });
                if (callback) callback();
                showMessage('success', 'Bot message successfully updated');
            } else {
                dispatch({
                    type: actionTypes.BOT_MESSAGE_UPDATION_ERROR,
                    payload: response,
                });
                showMessage('error', response && response.message ? response.message : 'Bot Message updation failed');
            }
        });
    };
}

export function createBotMessage(payload, callback) {
    return function (dispatch) {
        dispatch({
            type: actionTypes.BOT_MESSAGE_UPDATING,
        });

        API.createBotMessage(payload, (error, response) => {
            log('createBotMessage response', response);
            if (!error) {
                dispatch({
                    type: actionTypes.BOT_MESSAGE_CREATED,
                    payload: response,
                });
                if (callback) callback();
                showMessage('success',response && response.message && response.message.trim().length > 0 ? response.message : 'New bot message successfully created.');
            } else {
                dispatch({
                    type: actionTypes.BOT_MESSAGE_UPDATION_ERROR,
                    payload: response,
                });
                showMessage('error', response && response.message ? response.message : 'Unable to create new bot Message.');
            }
        });
    };
}

export function updateMessageFormData(payload) {
    return function (dispatch) {
        dispatch({
            type: actionTypes.UPDATE_MESSAGE_FORM_DATA,
            payload
        });
    };
}


// WEBPACK FOOTER //
// ./src/data/redux/botmessage_details/actions.js